import { Link } from 'wouter';
import { SEOMeta } from '../components/common/SEOMeta';
import { SectionTitle } from '../components/common/SectionTitle';
import { useScrollReveal } from '../hooks/useScrollReveal';
import { blogPosts } from '../constant/BlogPosts';
import '../assets/css/pages/Blog.css';
import BlogItem from '../components/pages/BlogItem';

export default function Blog() {
  const headerReveal = useScrollReveal();
  const gridReveal = useScrollReveal();

  const categoryColors: Record<string, string> = {
    'Web Dev': 'linear-gradient(135deg, #0f2027, #0f3460)',
    'Mobile': 'linear-gradient(135deg, #0f2027, #2c5364)',
    'Cloud': 'linear-gradient(135deg, #0a2342, #1e3a5f)',
    'Design': 'linear-gradient(135deg, #1f0533, #5a1091)',
    'AI/ML': 'linear-gradient(135deg, #0a3d0a, #1a5c1a)',
    'Security': 'linear-gradient(135deg, #1a0a0a, #7b2d2d)',
  };

  return (
    <>
      <SEOMeta
        title="Blog"
        description="IT insights, development tips, and tech trends from the Logicraft Infotech team."
      />
      <section className="page-header" ref={headerReveal.ref}>
        <div className={`container ${headerReveal.className}`}>
          <SectionTitle title="Our Blog" centered />
          <p className="page-header-desc" style={{ textAlign: 'center' }}>Insights, tutorials, and industry perspectives from our engineering team.</p>
        </div>
      </section>
      <section className="section" ref={gridReveal.ref}>
        <div className={`container ${gridReveal.className}`}>
          <div className="blog-grid-full">
            {blogPosts.map(post => (
              <Link href={`/blog/${post.slug}`} key={post.slug} className="blog-card-link">
                <BlogItem key={post.slug} post={post} />
              </Link>
            ))}
          </div>
        </div>
      </section>
    </>
  );
}